<template>
  <div>
    <modalUpload @save="saveFile"> </modalUpload>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 mb-5">
          <div class="col d-column">
            <h1
              class="title pt-2 mb-0"
              v-text="$ml.get('progCreateTitle')"
            ></h1>
            <h1 class="title">
              <span v-text="$ml.get('progCreateSubTitle')" class="pb-2"></span>
            </h1>

            <div
              v-if="
                !['owner', 'administrator'].includes(
                  this.$store.getters['getUser'].role
                )
              "
              class="card mb-3"
            >
              <div class="card-header">Opss...</div>
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <h2 class="size-1_4 p-3">
                    Usuários do tipo visualizador não tem permissão para criar
                    programas!
                  </h2>
                </div>
              </div>
            </div>

            <font v-else>
              <div class="card mb-3">
                <div class="card-header" v-text="$ml.get('summary')">
                  Resumo
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="m-2 mr-4">
                      <span class="position-relative padding1">
                        <div class="avatar-wrapper mb-2" @click="showModal()">
                          <img class="profile-pic" :src="avatar" />
                          <input
                            class="file-upload"
                            type="file"
                            accept="image/*"
                          />
                        </div>
                        <a @click="showModal()" class="ico-edit camUpload">
                          <img
                            src="../../../../src/assets/icons/camera.svg"
                            class="ico-16 m-1"
                          />
                        </a>
                      </span>
                    </div>
                    <div class="col w-100 form-group mt-2">
                      <label v-text="$ml.get('title')">Título</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="name"
                        :placeholder="$ml.get('standoutCreate')"
                        maxlength="255"
                      />
                      <transition name="fade">
                        <label
                          v-if="validateError && !$v.name.required"
                          class="lblError"
                          v-text="$ml.get('theNameOfTheProgramMustBInformed')"
                          >O nome do programa deve ser informado</label
                        >
                        <label
                          v-if="validateError && !$v.name.regexOTN"
                          class="lblError"
                          v-text="$ml.get('cannotEnterSpecialCharacters')"
                          >Não é possível inserir caracteres especiais</label
                        >
                        <label
                          class="lblError"
                          v-if="validateError && !$v.name.minLength"
                          v-text="
                            $ml
                              .with('f', 6)
                              .with('l', 255)
                              .get('theProgramNameMustBeBetweenAndCharacters')
                          "
                          >O nome do programa deve ter entre 3 e 255
                          caracteres</label
                        >
                      </transition>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div>
                        <textarea
                          maxlength="2000"
                          class="form-control-textarea text-are-mark"
                          rows="5"
                          v-model="description"
                          :placeholder="$ml.get('dashCreatNdaAbriefsummary')"
                        >
                        </textarea>
                      </div>
                      <transition name="fade">
                        <label
                          v-if="validateError && !$v.description.required"
                          class="lblError"
                          v-text="
                            $ml.get('theDescriptionOfTheProgramMustBeInformed')
                          "
                          >A descrição do programa deve ser informado</label
                        >
                        <label
                          class="lblError"
                          v-if="validateError && !$v.description.minLength"
                          v-text="
                            $ml
                              .with('f', 3)
                              .with('l', 30)
                              .get(
                                'theProgramDescriptionMustBeBetweenAndCharacters'
                              )
                          "
                          >A descrição do programa deve ter entre 3 e 30
                          caracteres!</label
                        >
                      </transition>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="d-column flex-row">
                  <div
                    class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
                  >
                    <!-- Configurações -->
                    <config
                      @programByObjective="programByObjective"
                      number="1"
                      :dataBudget="dataBudget"
                      :typeProgram.sync="typeProgram"
                      :activeObjective.sync="activeObjective"
                      :ndaRequired.sync="ndaRequired"
                      :vpnRequired.sync="vpnRequired"
                      :hofActive.sync="hofActive"
                      :slug.sync="slug"
                      :errorPolicy.sync="errorPolicy"
                      :errorSlug="
                        validateError &&
                        (!$v.slug.required || !$v.slug.minLength)
                      "
                      :errorTypeProgram="
                        validateError && !$v.typeProgram.required
                      "
                      @verify-Plan="verifyPlan"
                      @set-Nda="setNda"
                      @set-Vpn="setVpn"
                      @set-Hof="setHof"
                      :budgetMessageError="budgetMessageError"
                    />
                    <!-- Objetivo do programa -->
                    <programByObjective
                      v-if="programByObjectiveActive"
                      @registeredPrograms="listOfProgramsByObjective"
                      number="2"
                      :htmlText="htmlText"
                      :errorPolicy.sync="errorPolicy"
                      :errorList.sync="errorList"
                    />
                    <!-- Política do programa -->
                    <policy
                      :number="programByObjectiveActive ? '3' : '2'"
                      :htmlText="htmlText"
                      :policy.sync="policy"
                      :errorPolicy="
                        validateError &&
                        (!$v.policy.minLength || !$v.policy.required)
                      "
                    />
                    <!-- Escopo -->
                    <scope
                      :number="programByObjectiveActive ? '4' : '3'"
                      :listScop="listScop"
                      :typeProgram="typeProgram.id"
                      :validateError="validateError"
                    />
                    <!--  Fora de Escopo -->
                    <outOfScope
                      :number="programByObjectiveActive ? '5' : '4'"
                      :listScop="listOutOfScope"
                      :typeProgram="typeProgram.id"
                      :validateError="validateError"
                    />
                    <!-- Recompensas -->
                    <rewards
                      v-if="
                        typeProgram &&
                        typeProgram.id != 'vdp' &&
                        !programByObjectiveActive
                      "
                      number="5"
                      :bounty_severity="bounty_severity"
                      :optional_rewards="optional_rewards"
                      :getCurrency="getCurrency"
                    />

                    <!--  Usuários ativos -->
                    <userActives
                      number="6"
                      :selectedMembers="selectedMembers"
                    />
                    <!-- Concluir -->
                    <div class="d-flex align-self-start">
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <div
                          class="circle-number d-flex justify-content-center align-items-center"
                        >
                          <span>{{
                            typeProgram && typeProgram.id != "vdp" ? 7 : 6
                          }}</span>
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start">
                          <h2 class="size-1_4 m-0 pb-1">
                            <strong v-text="$ml.get('conclude')"
                              >Concluir</strong
                            >
                          </h2>
                          <p class="d-flex align-items-center">
                            <span
                              class="align-self-center"
                              v-text="$ml.get('haveYouRevised')"
                            >
                              Revisou seu programa? Então pronto!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-pending"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span class="pb-5"></span></div>
                      </div>
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div
                          class="d-flex flex-row justify-content-between align-items-start w-100"
                        >
                          <a
                            @click="validateForm()"
                            class="btn"
                            v-text="$ml.get('submitForReview')"
                            >Enviar para Análise</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </font>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import ProgramService from "../../../services/program.service";
// import PlanService from "../../../services/plan.service";
import $ from "jquery";
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import Config from "../../../components/company/program/config.vue";
import OutOfScope from "../../../components/company/program/out_of_scope.vue";
import Policy from "../../../components/company/program/policy.vue";
import programByObjective from "../../../components/company/program/programByObjective.vue";
import Rewards from "../../../components/company/program/rewards.vue";
import Scope from "../../../components/company/program/scope.vue";
import userActives from "../../../components/company/program/userActives.vue";
import modalUpload from "../../../components/modalUpload.vue";
import { utils } from "../../../utils";

const regexOTN = utils.regexCheck("OTN");

export default {
  components: {
    modalUpload,
    Config,
    Scope,
    OutOfScope,
    Rewards,
    Policy,
    userActives,
    programByObjective,
  },
  data() {
    return {
      errorPolicy: "",
      errorProgram: false,
      errorList: "",
      listsProgramsBySelectedObjectives: [],
      programByObjectiveActive: false,
      loading: false,
      validateError: false,
      avatar: require("../../../assets/images/empty.png"),
      file: null,
      user: null,
      input: ``,
      name: "",
      description: "",
      slug: "",
      typeProgram: { id: "public", name: "public" },
      ndaRequired: { id: "no", name: "no" },
      vpnRequired: { id: "no", name: "no" },
      hofActive: { id: "no", name: "no" },
      policy: "",
      htmlText: "",
      activeObjective: false,

      listScop: [],
      listOutOfScope: [],

      txtOtherRewards: null,
      bounty_severity: [],
      optional_rewards: [],
      selectedManagers: [],
      currenry: "",
      budgetRegistration: null,
      budgetMessageError: {
        budgetValue: "",
        notification: "",
        breakPercentage: "",
      },
    };
  },

  validations: {
    name: { required, regexOTN, minLength: minLength(6) },
    description: { required, minLength: minLength(3) },
    slug: { minLength: minLength(2) },
    typeProgram: { required },
    policy: { required, minLength: minLength(3) },
    listScop: { required },
  },

  mounted() {
    this.user = this.$store.getters["getUser"];
    this.policy = `Nenhuma tecnologia é perfeita, e ${
      this.user.companyName ?? "BugHunt"
    } acredita que trabalhar com pesquisadores de segurança qualificados em todo o mundo é crucial para identificar pontos fracos em qualquer tecnologia. Se você acredita ter encontrado um problema de segurança em nosso produto ou serviço, recomendamos que você nos notifique. É bom trabalhar com você para resolver o problema imediatamente.

##### Política de divulgação
* Informe-nos o mais breve possível após a descoberta de um possível problema de segurança, e faremos todos os esforços para resolvê-lo rapidamente.
* Forneça um tempo razoável para resolver o problema antes de qualquer divulgação ao público ou a terceiros.
* Faça um esforço de boa fé para evitar violações da privacidade, destruição de dados e interrupção ou degradação do nosso serviço. Interaja apenas com contas que você possui ou com permissão explícita do titular da conta.
* Vulnerabilidades descobertas através de credenciais/informações vazadas, (exemplo: em fontes públicas, como Trello, GitHub, Wayback, Intelx, Foruns etc.), não são elegíveis para recompensas.
* Vulnerabilidades em sistemas fora do escopo não serão aceitas, nem consideradas para pontuação ou agradecimentos públicos.
* Os pesquisadores não estão autorizados a realizar quaisquer ações além da descoberta inicial e relato, incluindo tentar acessar ou manipular quaisquer contas ou dados associados às credenciais relatadas.

##### Exclusões
Ao pesquisar, gostaríamos de pedir que você se abstenha de:
* Clickjacking em páginas sem informações sensíveis;
* Self-xss;
* Enumeração de nome de usuário/e-mail por meio da página de login ou através de mensagens de erro na página de "Esqueceu a senha";
* CSRF não autenticado /logout/login;
* CSRF em ações não críticas;
* Falta de cabeçalhos HTTP relacionados à segurança que não levam diretamente a uma vulnerabilidade;
* Vulnerabilidades do lado do cliente baseadas em Flash, como Flash XSS;
* Redirecionamento aberto do Flash ou Injeção de conteúdo do Flash;
* Vulnerabilidades identificadas anteriormente;
* Ataques que exigem acesso físico ou MITM (Man in the middle);
* Bibliotecas com versões vulneráveis conhecidas sem uma PoC funcionando (ex. jQuery Libraries);
* CSV injection attack sem demonstrar uma PoC;
* Melhores práticas de configurações em SSL/TLS;
* Ataques de brute-force em formulários de autenticação;
* Páginas de erros de stack trace (401/403/500) sem uma comprovação de vulnerabilidade;
* Método HTTP OPTIONS habilitado;
* Qualquer atividade que possa levar à interrupção do nosso serviço (ex. DoS);
* Contect spoofing e text injection sem mostrar um vetor de ataque ou sem poder alterar o HTML/CSS;
* Aplicativos, scripts e integrações não oficiais de terceiros;
* Engenharia social (incluindo phishing) na nossa equipe ou terceiros;
* Registros SPF (Sender Policy Framework) inválidos ou ausentes (SPF/DMARC/DKIM incompleto ou ausente);
* Quaisquer tentativas físicas contra nossas propriedades ou data centers;
* Informações de divulgação insensíveis, (ex. versão do software);
* Disclosure de informações com baixo risco;
* Cross-site scripting em navegadores obsoletos;
* Relatórios de scanners automatizados de vulnerabilidades que não são validados (ou seja, falsos positivos);
* Contect spoofing e text injection sem mostrar um vetor de ataque ou sem poder alterar o HTML/CSS;
* Problemas de captura de banner (como encontrar informações como o nome do servidor da web etc.);
* Complexidade da senha;
* Não possui confirmação de e-mail;
* Spamming;
* Negação de serviço;
* Tabnabbing.
* Falta de rate limiting.
* Falta de flags no cookies (ex. HttpOnly, SameSite, Secure).
* Falta de security headers (ex. CSP / HSTS / X-Frame-Options / X-Content-Type-Options).
* Uso de ferramentas automatizadas que podem gerar tráfego significativo e possivelmente prejudicar o funcionamento de nossa aplicação.
* Subresource Integrity (SRI) não implementada.
* Cabeçalho HSTS ausente.
* Bugs divulgados publicamente em software de internet no prazo de 7 dias após sua divulgação.

##### Respaldo legal
Quaisquer atividades conduzidas de maneira consistente com esta política serão consideradas conduta autorizada e não iniciaremos uma ação legal contra você. Se uma ação legal for iniciada por terceiros contra você em relação às atividades conduzidas sob esta política, tomaremos medidas para tornar claro que suas ações foram conduzidas em conformidade com esta política.

Obrigado por ajudar a manter ${
      this.user.companyName ?? "BugHunt"
    } e nossos usuários em segurança!`;

    if (this.$route.fullPath.split("?")[1]) {
      let type = this.$route.fullPath.split("?")[1];
      if (type == "vdp") {
        this.typeProgram = { id: "vdp", name: "VDP" };
      } else if (type == "public") {
        this.typeProgram = { id: "public", name: "public" };
      } else if (type == "private") {
        this.typeProgram = { id: "private", name: "private" };
      } else if (type == "target") {
        this.activeObjective = true;
      }
    } else {
      this.typeProgram = { id: "public", name: "public" };
    }

    $("html, body").animate({ scrollTop: 0 }, "5000");
  },
  watch: {
    listsProgramsBySelectedObjective() {
      this.errorPolicy = "";
    },
    budgetRegistration: {
      handler() {
        const { budgetValue, notification, pauseProgram } =
          this.budgetRegistration;
        if (budgetValue && this.budgetMessageError.budgetValue)
          return (this.budgetMessageError.budgetValue = false);
        if (notification && this.budgetMessageError.notification)
          return (this.budgetMessageError.notification = false);
        if (pauseProgram && this.budgetMessageError.breakPercentage)
          return (this.budgetMessageError.breakPercentage = false);
      },
      deep: true,
    },
  },
  methods: {
    listOfProgramsByObjective(data) {
      const filteredData = data?.registeredPrograms.map(
        ({ currency, ...rest }) => ({
          ...rest,
          currency: currency.value,
        })
      );
      this.listsProgramsBySelectedObjectives = filteredData;
      this.errorPolicy = "";
    },
    programByObjective(data) {
      this.programByObjectiveActive = data.programByObjective;
    },
    dataBudget(value) {
      this.budgetRegistration = value;
    },
    getCurrency(value) {
      this.currenry = value;
    },
    selectedMembers(data) {
      let filterManagersId = data?.map((it) => it?._id);
      this.selectedManagers = filterManagersId ?? [];
    },
    async setNda(ndaRequired) {
      this.ndaRequired = ndaRequired;
    },

    async setVpn(vpnRequired) {
      this.vpnRequired = vpnRequired;
    },

    async setHof(hofActive) {
      this.hofActive = hofActive;
    },

    async verifyPlan(typeProgram) {
      this.typeProgram = typeProgram;

      // Descomentar quando os planos forem implementados
      // var self = this;
      // let  typeMl = type != 'vdp' ? self.$ml.get(type) : 'vdp';

      // if(this.$store.getters['getUser'].plan){
      //   PlanService.getVerifyPlan(`program_${type}`).then(
      //     (response) => {
      //       if(response.data == 'limit_exceeded'){
      //         Swal.fire({
      //           icon: 'info',
      //           html: `<h3 class="mb-2">${self.$ml.with(typeMl).get('programsLimitReached')}<h3>
      //           <h5 class="mb-2">${self.$ml.get('toAddMorePrograms')} <a href="/account?plans">${self.$ml.get('here')}</a>
      //           </h5>`,
      //           showConfirmButton: false,
      //           timer: 10000,
      //           onClose: () => {
      //             self.$router.back();
      //           }
      //         });
      //       }
      //     },
      //     (error) => {
      //       console.dir(error)
      //     }
      //   );
      // }
    },

    showModal() {
      this.$bvModal.show("modal-upload-avatar");
      setTimeout(() => {
        $("#avatarEditorCanvas").click();
      }, 50);
    },

    saveFile(file) {
      this.file = file.file;
      this.avatar = file.src;
    },
    validateForm() {
      this.errorList = "";
      this.loading = true;
      var self = this;

      // stop here if form is invalid
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        (!this.slug && this.typeProgram.id != "private")
      ) {
        if (
          this.programByObjectiveActive === true &&
          this.listsProgramsBySelectedObjectives.length === 0
        ) {
          this.errorPolicy = "error";
        }
        if (this.budgetRegistration?.activateBudget) {
          const { budgetValue, notification, pauseProgram, breakPercentage } =
            this.budgetRegistration;
          if (budgetValue < 0) return;
          if (notification < 0 || notification > 100 || isNaN(notification))
            return;
          if (
            breakPercentage < 0 ||
            breakPercentage > 100 ||
            isNaN(breakPercentage)
          )
            return;
          if (!budgetValue) {
            this.budgetMessageError.budgetValue = true;
          }
          if (!notification) {
            this.budgetMessageError.notification = true;
          }
          if (pauseProgram && !breakPercentage) {
            this.budgetMessageError.breakPercentage = true;
          }
        }
        this.validateError = true;
        this.loading = false;
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      if (this.budgetRegistration?.activateBudget) {
        const { budgetValue, notification, pauseProgram, breakPercentage } =
          this.budgetRegistration;
        if (budgetValue < 0) return;
        if (notification < 0 || notification > 100 || isNaN(notification))
          return;
        if (
          breakPercentage < 0 ||
          breakPercentage > 100 ||
          isNaN(breakPercentage)
        )
          return;
        if (!budgetValue) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.budgetValue = true;
          return;
        }
        if (!notification) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.notification = true;
          return;
        }
        if (pauseProgram && !breakPercentage) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.breakPercentage = true;
          return;
        }
      }
      if (
        this.programByObjectiveActive === true &&
        this.listsProgramsBySelectedObjectives.length === 0
      ) {
        this.errorPolicy = "error";
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");

        this.loading = false;
        return;
      }

      this.validateError = false;
      this.saveProgram();
    },

    saveProgram() {
      var self = this;

      const formData = new FormData();

      formData.append("file", this.file);
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("managers", JSON.stringify(this.selectedManagers));

      if (this.slug && this.typeProgram.id != "private") {
        formData.append("slug", this.slug);
      }

      formData.append("type", this.typeProgram?.id);
      formData.append("nda", String(this.ndaRequired?.id));
      formData.append("vpn_required", String(this.vpnRequired?.id));
      formData.append("policy", this.policy);
      formData.append("scope", JSON.stringify(this.listScop));
      formData.append("out_of_scope", JSON.stringify(this.listOutOfScope));

      formData.append("bounty_low", this.bounty_severity.bounty_low);
      formData.append("bounty_medium", this.bounty_severity.bounty_medium);
      formData.append("bounty_high", this.bounty_severity.bounty_high);
      formData.append("bounty_critical", this.bounty_severity.bounty_critical);
      formData.append("currency", this.currenry);
      formData.append(
        "ranking_type",
        this.hofActive?.id == "yes" ? "hall" : "standard"
      );

      if (this.programByObjectiveActive) {
        const target_settings = {
          active: true,
          targets: this.listsProgramsBySelectedObjectives.map((obj) => {
            delete obj.edit;
            return obj;
          }),
        };
        formData.append("target_settings", JSON.stringify(target_settings));
      }

      const budgetObj = {
        budget: {
          active: this.budgetRegistration?.activateBudget,
          max_value: this.budgetRegistration?.budgetValue,
          percentage_alert: this.budgetRegistration?.notification,
          pause_program: this.budgetRegistration?.pauseProgram,
          percentage_pause: this.budgetRegistration?.breakPercentage,
        },
      };
      if (this.budgetRegistration?.activateBudget) {
        formData.append("settings", JSON.stringify(budgetObj));
      }

      formData.append(
        "optional_rewards",
        JSON.stringify(this.optional_rewards)
      );

      ProgramService.postProgram(formData).then(
        () => {
          self.loading = false;
          Swal.fire({
            icon: "success",
            title: self.$ml.get("successfullyCreatedProgram"),
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.$router.push("/program");
          });

          this.programByObjectiveActive = false;
        },
        (error) => {
          self.loading = false;
          const splitMessage = error.response.data.message.split("_");
          const errorType = splitMessage[1] + splitMessage[2] + splitMessage[3];

          const statusCode = error.response.data.statusCode;
          const errMessage = error.response.data.message;

          if (
            statusCode === 422 &&
            errMessage === "Informar no máximo 5 Objetivos!"
          ) {
            this.errorList = "error";
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });

            return;
          }

          if (errorType === "programlimitexceeded") {
            const programType = splitMessage[0];
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml
                .with(
                  "programType",
                  programType === "vdp" ? "VDP" : self.$ml.get(programType)
                )
                .get("typeProgramLimitExceeded"),
            });
          } else if (errorType === "scopelimitexceeded") {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("scopeLimitExceeded"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com essa slug!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyProgramSlug"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com esse nome!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyAprogram"),
            });
          } else {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        }
      );
    },
  },
};
</script>
<style>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

.editor-toolbar {
  border: 0px !important;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
</style>
